class CollectionFilter extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      item: '.collection-filter__item',
      products: '#collection-grid-wrapper'
    }

    this.setupEventListeners()
    this.setupPopstateListener()
  }

  setupEventListeners () {
    this.addEventListener('click', (event) => {
      if (event.target.closest(this.selectors.item)) {
        event.preventDefault()

        const url = event.target.href

        if (url && url !== '#' && location.href !== url) {
          history.pushState(null, null, url)

          Array.from(this.querySelectorAll(this.selectors.item))
            .forEach(item => item.classList.remove('active'))

          event.target.classList.add('active')

          this.fetchProducts(url)
        }
      }
    })
  }

  setupPopstateListener () {
    window.addEventListener('popstate', () => {
      const url = location.href

      // Sync active state of filter items to current URL
      Array.from(this.querySelectorAll(this.selectors.item))
        .forEach(item => {
          if (item.href === url) {
            item.classList.add('active')
          } else {
            item.classList.remove('active')
          }
        })

      this.fetchProducts(url)
    })
  }

  fetchProducts (url) {
    fetch(`${url}?sections=main-collection-product-grid`)
      .then(response => response.json())
      .then(data => {
        const products = document.querySelector(this.selectors.products)
        const parser = new DOMParser()
        const doc = parser.parseFromString(data['main-collection-product-grid'], 'text/html')

        if (products) {
          products.replaceWith(doc.querySelector(this.selectors.products))

          if (typeof loadReviewsIoRatingSnippets === 'function') {
            loadReviewsIoRatingSnippets()
          }
        }
      })
  }
}

customElements.define('collection-filter', CollectionFilter)
